const Footer = () => {
  return (
    <div className="pt-3 flex justify-center">
      <p className="text-sm text-gray-400 font-semibold select-none">© 2023 Amara Fofana</p>
    </div>
  );
};

export default Footer;